import { FC, Fragment } from "react";
import { Label, Listbox, ListboxOptions, Transition } from "@headlessui/react";

import { classNames } from "../../utils/Helpers";
import { ListBoxProps } from "../../utils/Interfaces";

export const ListBox: FC<ListBoxProps> = ({ label, value, width, button, options, eventHandler }) => {
    return (
        <Listbox value={value} onChange={event => eventHandler(event)}>
            {({ open }) => (
                <>
                    {
                        label && (
                            <Label className="block w-full mb-1">
                                {label}
                            </Label>
                        )
                    }

                    {button}

                    {
                        options && (
                            <Transition show={open} as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                                <div className="max-h-44 z-50 rounded shadow relative w-full">
                                    <ListboxOptions style={{ width: width }} className="absolute z-30 mt-1 origin-top-right bg-white dark:bg-gray-900 text-slate-600 dark:text-slate-300 shadow-lg max-h-44 w-full rounded-md p-1.5 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm flex flex-col gap-y-1 ring-black/5 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in
                                        ">
                                        {options}
                                    </ListboxOptions>
                                </div>
                            </Transition>
                        )
                    }
                </>
            )}
        </Listbox>
    )
}